import {
    logOperationalMetric,
    isResponseCode5xx, setAliasToTriggerMHEValidationRequest
} from "../../util/Util";
import {getMHEValidations, getPresignedURLcall, triggerMHEValidations} from "../../resources/MHEValidationResource";
import {
    ALERT_MHE_VALIDATION_FAILED_MESSAGE,
    ALERT_MHE_VALIDATION_REPORT_DOES_NOT_EXIST,
    MERIDIAN_ALERT_TYPE
} from "../../util/Constants";

const metricProcessName = "MHE_VALIDATION_DETAILS";

export function fetchMheValidationDetails(dispatcher, macAddress) {
    const request = {
        macAddress: macAddress
    }
    getMHEValidationDetails(dispatcher, request)
}

export function triggerMheValidationDetails(dispatcher, triggerData, showCustomAlert) {
    const request = {
        triggerData: triggerData
    }

    triggerMHEValidation(dispatcher, request, showCustomAlert)
}

export function getPresignedURL(dispatcher, objectKey, showCustomAlert) {
    getPresignedURLdata(dispatcher, objectKey, showCustomAlert)
}

async function getMHEValidationDetails(dispatcher, request) {

        const startTime = Date.now();
        const response = await getMHEValidations(request.macAddress)
        const isSuccess = response.status === 200;
        const isFault = isResponseCode5xx(response.status)

        // Log operation
        logOperationalMetric(startTime, metricProcessName, "getMHEValidationData", isSuccess, isFault);


    if (response.data) {
        // return data to page
        dispatcher({type: "RECEIVE_DATA", data: {mheValidationInformation: response.data}});
    } else {
        dispatcher({type: "RECEIVE_DATA", data: {mheValidationInformation: {mheValidationInstanceList:[]}}});
    }
}

async function triggerMHEValidation(dispatcher, request, showCustomAlert) {
    await setAliasToTriggerMHEValidationRequest(request);
    const startTime = Date.now();
    const response = await triggerMHEValidations(request.triggerData)
    const isSuccess = response.status === 200;
    const isFault = isResponseCode5xx(response.status)

    if (isFault) {
        showCustomAlert(ALERT_MHE_VALIDATION_FAILED_MESSAGE, MERIDIAN_ALERT_TYPE.ERROR);
    }

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "triggerMHEValidationData", isSuccess, isFault);
    fetchMheValidationDetails(dispatcher, request.triggerData.macAddress)
}

async function getPresignedURLdata(dispatcher, objectKey, showCustomAlert) {

    const startTime = Date.now();
    const response = await getPresignedURLcall(objectKey)
    const isSuccess = response.status === 200;
    const isFault = isResponseCode5xx(response.status)

    // Log operation
    logOperationalMetric(startTime, metricProcessName, "getPresignedUrl", isSuccess, isFault);

    if (isSuccess && response.data && response.data.presignedUrl) {
        window.open(response.data.presignedUrl, "_self");
    }

    if (isFault) {
        showCustomAlert(ALERT_MHE_VALIDATION_REPORT_DOES_NOT_EXIST, MERIDIAN_ALERT_TYPE.ERROR);
    }
}





// WEBPACK FOOTER //
// ./src/components/mhevalidation/network/MHEValidationNetworkAPI.js